// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { ExpanderButton } from "../../../../components/expander_button/ExpanderButton";
import { RangeSlider } from "../../../../components/range_slider/RangeSlider";
import {
  CabType,
  DriveType,
  ProductFilterBranche,
  ProductFilterModelSerie,
  ProductFilterModelSerieVariant,
  RoofType,
  SteeringType,
} from "../../../../common/interfaces/conversionworld/ProductFilter";

@Component({
  mixins: [template],
  components: {
    ExpanderButton,
    RangeSlider,
  },
})
export default class ModelSeries extends Vue {
  @Prop({
    default: () => {
      return {};
    },
  })
  public instance!: object;

  @Prop({ default: false })
  public useKonsiFilter!: boolean;

  get filterStore() {
    if (this.useKonsiFilter) {
      return this.$store.conversionWorldKonsiFilter;
    }

    return this.$store.conversionWorldProductFilter;
  }

  checked: any[] = [];

  refineOpen = "";
  variantOpen = "";
  currentModel = {};
  variant = {};
  modelActive = "";

  created() {}

  private checkRefineOptions(variant) {
    if (
      (variant.wheelbase && variant.wheelbase.length > 1) ||
      (variant.gross_weight && variant.gross_weight.length > 1) ||
      (variant.cab_types && variant.cab_types.length > 1) ||
      (variant.roof_types && variant.roof_types.length > 1) ||
      (variant.drive_types && variant.drive_types.length > 1)
    ) {
      return true;
    }
    return false;
  }

  private checkVariant(model, variant) {
    variant.model = model.id;
    let index = this.checked.findIndex((i) => {
      if (i.id == variant.id && i.model === model.id) {
        return true;
      }
      return false;
    });
    if (index >= 0) {
      this.checked.splice(index, 1);
    } else {
      variant.selectedDriveTypes = [];
      variant.selectedRoofTypes = [];
      variant.selectedCabTypes = [];
      variant.selectedWheelbase = {
        min: variant.wheelbase[0],
        max: variant.wheelbase[variant.wheelbase.length - 1],
      };
      variant.selectedGrossWeight = {
        min: variant.gross_weight[0],
        max: variant.gross_weight[variant.gross_weight.length - 1],
      };
      this.checked.push(variant);
    }

    this.$emit("toogleFilter", "model_series", variant);
  }

  private refineFilter(model, variant, event?) {
    if (event) event.preventDefault();

    this.currentModel = model;
    this.variant = variant;
    if (this.variantOpen === variant.id) {
      this.variantOpen = "";
      this.refineOpen = "";
    } else {
      this.variantOpen = variant.id;
      this.refineOpen = model.id;
    }
  }

  private handleCloseRefine($event) {
    $event.preventDefault();
    this.refineOpen = "";
  }

  private handleToogleModel(model) {
    this.modelActive = this.modelActive == model ? "" : model;
  }

  get filters() {
    if (this.filterStore.filterData) {
      return this.filterStore.filterData.model_series.filter(
        (x) => x.count > 0
      );
    }

    return [];
  }

  private isChecked(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant
  ) {
    return this.filterStore.filter.model_series.find(
      (x) => x.model == model.id && x.variant == variant.id
    );
  }

  private onInput(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant,
    value
  ) {
    if (value) {
      if (!this.isChecked(model, variant)) {
        this.filterStore.addFilterTag("model_series", {
          model: model,
          variant: variant,
        });
      }
    } else {
      this.filterStore.removeFilterTag("model_series", {
        model: model,
        variant: variant,
      });
      this.variant = {};
      this.refineOpen = "";
    }
  }

  private onInputWheelbase(model, variant, { min, max }) {
    let ms = this.filterStore.filter.model_series.find(
      (x) => x.model == model.id && x.variant == variant.id
    );
    if (ms) {
      Vue.set(ms, "wheelbase", { min: min as number, max: max as number });
    }
  }

  private onInputGrossWeight(model, variant, { min, max }) {
    let ms = this.filterStore.filter.model_series.find(
      (x) => x.model == model.id && x.variant == variant.id
    );
    if (ms) {
      Vue.set(ms, "gross_weight", { min: min as number, max: max as number });
    }
  }

  private isCheckedCabType(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant,
    type: CabType
  ) {
    return this.filterStore.filter.model_series.find(
      (x) =>
        x.model == model.id &&
        x.variant == variant.id &&
        x.cab_types &&
        x.cab_types.includes(type.id)
    );
  }

  private onInputCabType(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant,
    type: CabType,
    value
  ) {
    if (value) {
      let ms = this.filterStore.filter.model_series.find(
        (x) => x.model == model.id && x.variant == variant.id
      );

      if (ms) {
        if (!ms.cab_types) {
          Vue.set(ms, "cab_types", []);
        }

        ms.cab_types!.push(type.id);
      }
    } else {
      let ms = this.filterStore.filter.model_series.find(
        (x) => x.model == model.id && x.variant == variant.id
      );

      if (ms && ms.cab_types) {
        ms.cab_types = ms.cab_types.filter((x) => x != type.id);
      }
    }
  }

  private isCheckedSteeringType(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant,
    type: SteeringType
  ) {
    return this.filterStore.filter.model_series.find(
      (x) =>
        x.model == model.id &&
        x.variant == variant.id &&
        x.steering_types &&
        x.steering_types.includes(type.id)
    );
  }

  private onInputSteeringType(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant,
    type: SteeringType,
    value
  ) {
    if (value) {
      let ms = this.filterStore.filter.model_series.find(
        (x) => x.model == model.id && x.variant == variant.id
      );

      if (ms) {
        if (!ms.steering_types) {
          Vue.set(ms, "steering_types", []);
        }

        ms.steering_types!.push(type.id);
      }
    } else {
      let ms = this.filterStore.filter.model_series.find(
        (x) => x.model == model.id && x.variant == variant.id
      );

      if (ms && ms.steering_types) {
        ms.steering_types = ms.steering_types.filter((x) => x != type.id);
      }
    }
  }

  private isCheckedRoofType(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant,
    type: RoofType
  ) {
    return this.filterStore.filter.model_series.find(
      (x) =>
        x.model == model.id &&
        x.variant == variant.id &&
        x.roof_types &&
        x.roof_types.includes(type.id)
    );
  }

  private onInputRoofType(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant,
    type: RoofType,
    value
  ) {
    if (value) {
      let ms = this.filterStore.filter.model_series.find(
        (x) => x.model == model.id && x.variant == variant.id
      );

      if (ms) {
        if (!ms.roof_types) {
          Vue.set(ms, "roof_types", []);
        }

        ms.roof_types!.push(type.id);
      }
    } else {
      let ms = this.filterStore.filter.model_series.find(
        (x) => x.model == model.id && x.variant == variant.id
      );

      if (ms && ms.roof_types) {
        ms.roof_types = ms.roof_types.filter((x) => x != type.id);
      }
    }
  }

  private isCheckedDriveType(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant,
    type: DriveType
  ) {
    return this.filterStore.filter.model_series.find(
      (x) =>
        x.model == model.id &&
        x.variant == variant.id &&
        x.drive_types &&
        x.drive_types.includes(type.id)
    );
  }

  private onInputDriveType(
    model: ProductFilterModelSerie,
    variant: ProductFilterModelSerieVariant,
    type: DriveType,
    value
  ) {
    if (value) {
      let ms = this.filterStore.filter.model_series.find(
        (x) => x.model == model.id && x.variant == variant.id
      );

      if (ms) {
        if (!ms.drive_types) {
          Vue.set(ms, "drive_types", []);
        }

        ms.drive_types!.push(type.id);
      }
    } else {
      let ms = this.filterStore.filter.model_series.find(
        (x) => x.model == model.id && x.variant == variant.id
      );

      if (ms && ms.drive_types) {
        ms.drive_types = ms.drive_types.filter((x) => x != type.id);
      }
    }
  }
}
